import React from "react";

const RollingLoader = (props) => {
    return(<>
        <div className="small-12 medium-12 column" style={{textAlign:"center"}}>
                    <span><img alt="RollingLoader" className="rollingLoader colorize-black"
                               src={"assets/img/rolling_loader.svg"}/> </span>
        </div>

    </>);
}
export default RollingLoader;